var copyTextareaBtn = document.querySelector('.js-textareacopybtn');
  
copyTextareaBtn.addEventListener('click', function(event) {
  var copyTextarea = document.querySelector('.js-copytextarea');
  copyTextarea.focus();
  copyTextarea.select();
  copyTextarea.setSelectionRange(0, 99999);
      try {
        var successful = navigator.clipboard.writeText(copyTextarea.value);
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying' + msg);
      } catch (err) {
        console.log('Unable to copy');
      }
    });